// extracted by mini-css-extract-plugin
export default {"overlay":"PreviewCard_overlay__DW46M"};